module.exports = "/assets/data/87fa2029f123244aa79e40c82e650df8-SW1X.data.json";